var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.381836,
    width: 20.1356,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(0.0530306) scale(0.029798 0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABfklEQVRIie2UsUrDUBSGvxOUgvgAFevSd1AXQXc3H0H02F3cswrifHNT6lOIk5M6uLq4uKhV6iAZi9DmurQgmMRb0wxK/+WQc3LOd27uT2Cm/y4BUNVtIAKWpzi765zTOI4vsorBKJopQwEaIhLlFcfgxpShY63kFeYycudBEBwYY14qWiYbnKZpy1pbKTQT3G63u1C94YKClyo1XBG4UsMVgX10KyKr/X5/UUR2gXffxixX++pjMBjsdDqd19HzmapeAg/A/E/NZU58/wUKgLX2SUTufJrLgGtZSefcQtXgvF6vmWXAzVartfY1oarrQLNq8PxwODwOw3AOYBSP8TBWWTAistXr9RoAo7jp2zsGd3/BTUTkxBjzCFCv15+cc6dA4g12zukE8J6I7CVJUo+i6AhwAGEYpnEcH9ZqtSVgH3grGiJ5BVV1mZsGwYYx5uan7VR1A7jKqllrZeI/V5qm16o6ads3FZnrN/fuo+dC8IT37g0VkfKfa6Y/oU8ZVX5KvO9DZgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.c2dbb03ef7a2eb33337fbafb4733e518.svg";
export { ForwardRef as ReactComponent };